import { render, staticRenderFns } from "./MultiLineText.vue?vue&type=template&id=fb4123c2"
import script from "./MultiLineText.vue?vue&type=script&lang=js"
export * from "./MultiLineText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports